import { RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalModule } from 'ngx-modal';

import { ModalService } from '../../services/modal.service';
import { ModalComponent } from './modal.component';


export class PlannerModalModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    RouterModule,
    ModalModule
  ],
  declarations: [
    ModalComponent
  ],
  providers: [
    ModalService
  ],
  exports: [
    ModalComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
